// extracted by mini-css-extract-plugin
export default {"modalHeader":"CustomModal_modalHeader__E3ttC","btn":"CustomModal_btn__46nW+"};